import DashboardSection from "./DashboardSection";

import "./DashboardAlerts.css";

export default function DashboardAlerts({ alerts = [] }) {
  return (
    <DashboardSection
      title="Aandachtspunten"
      description="Belangrijke meldingen."
    >
      <div className="dashboard-alerts">
        {alerts.length === 0 ? (
          <div className="dashboard-alerts__empty">Geen meldingen.</div>
        ) : (
          alerts.map((alert, index) => (
            <div key={alert.key || index} className="dashboard-alerts__item">
              <strong>{alert.title || alert.message || "Melding"}</strong>

              {alert.description && <p>{alert.description}</p>}
            </div>
          ))
        )}
      </div>
    </DashboardSection>
  );
}
